<template>
  <el-dialog
    class="yh-dialog"
    v-bind="$attrs"
    :width="width"
    :visible.sync="showing"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <slot></slot>
    <template slot="footer">
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'YhDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '500px',
    },
  },
  computed: {
    showing: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      },
    },
  },
};
</script>

<style lang="scss">
.yh-dialog {
  // 统一样式规范：
  // 弹窗宽度 500px，顶部 title 居左，底部按钮居右
  // 输入框宽度 320px lable 宽度 100px，可换行
  // form 居中偏左 10 像素
  .el-dialog__body {
    display: flex;
    justify-content: center;
  }
  .el-form {
    width: 420px;
  }
  .el-form--inline .el-form-item {
    margin-right: 0;
  }
  .el-form-item__error {
    position: relative;
    width: 320px !important;
    text-align: justify;
  }
  .el-input,
  .el-textarea {
    width: 320px;
  }
  .el-form-item__label {
    width: 100px;
    position: relative;
    top: 15px;
    transform: translate(0, -50%);
  }
  .el-form-item__content {
    line-height: 30px;
  }
  .el-form-item__label {
    line-height: 1.2em;
  }
  .el-form-item {
    margin-bottom: 16px;
  }
  .el-form {
    transform: translate(-10px, 0);
  }
}
</style>
